// extracted by mini-css-extract-plugin
export default {"button":"Test_button__Pnsjq","red":"Test_red__RcDtu","green":"Test_green__FoI1p","disabled":"Test_disabled__dZwV2"};